import { AxiosResponse } from "axios";
import { IDataResponse } from "../../interfaces/response/IResponse";
import useAxios from "../../../hooks/useAxios/useAxios";
import { useCallback } from "react";

export const useGetPing = (): {
    isLoading: boolean,
    cancel: () => void,
    getPing: () => Promise<AxiosResponse<IDataResponse<string>> | undefined>
} => {
    const {execute, isLoading, cancel} = useAxios<IDataResponse<string>>({
        method: 'get',
    });

    const getPing = useCallback(async () => await execute(undefined, {
        url: `/api/${process.env.REACT_APP_API_VERSION}/session/ping`
    }), [execute]);

    return {getPing, isLoading, cancel};
};